import React, { useState, useEffect, useRef } from "react";
import OrderTracking from "./components/OrderTracking";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { verify2fa } from "./api/api";
import './App.css';
import Header from './components/layout/HeaderX';
import Navigation from './components/layout/Navigation';

import Home from './components/HomeX';
import Login from './components/auth/Login';
import Logout from './components/auth/Logout';
import PrivateRoute from './components/auth/PrivateRoute';
import Footer from './components/layout/Footer';
import { SearchContext } from './components/layout/SearchContext';
// import Rightbar from './components/layout/Rightbar';
// import Chatpanel from './components/layout/Chatpanel';
import Modal from './components/layout/Modal';

import Academy from './components/Academy';
import Account from './components/Account';
import Bookmarks from './components/Bookmarks';
import Cassa from './components/Cassa';
import Rewards from './components/Rewards';
import Rubrica from './components/Rubrica';
import Statistiche from './components/Statistiche';
import Turni from './components/Turni';

function App() {
  const location = useLocation();
  const [title, setTitle] = useState("");
  const [userDetails, setUserDetails] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchMounted, setSearchMounted] = useState(false);
  const [searchTop, setSearchTop] = useState(120);
  const [searchTerm, setSearchTerm] = useState('');
  const searchInputRef = useRef(null);

  const toggleSearch = () => setSearchOpen((open) => !open);
  const searchPlaceholders = {
    '/account': 'Cerca contatti o premi...',
    '/rewards': 'Cerca premi...',
    '/rubrica': 'Cerca per nome, cognome o descrizione...',
    '/bookmarks': 'Cerca categorie o link...',
  };
  const searchPlaceholder = searchPlaceholders[location.pathname] || 'Cerca...';

  useEffect(() => {
    setSearchTerm('');
    setSearchOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (searchOpen) {
      setSearchMounted(true);
      return undefined;
    }
    // Mantiene la barra montata il tempo della dissolvenza
    const timer = setTimeout(() => setSearchMounted(false), 200);
    return () => clearTimeout(timer);
  }, [searchOpen]);

  useEffect(() => {
    if (!searchOpen) return undefined;

    const header = document.querySelector('.header-top');
    if (!header) return undefined;

    const updateSearchPosition = () => {
      setSearchTop(header.getBoundingClientRect().bottom + 8);
    };

    updateSearchPosition();
    window.addEventListener('resize', updateSearchPosition);
    return () => window.removeEventListener('resize', updateSearchPosition);
  }, [searchOpen]);

  useEffect(() => {
    // Mappa delle route con i titoli corrispondenti
    const routeTitles = {
      '/login': 'Login',
      '/': 'Home',
      '/academy': 'Academy',
      '/account': 'Account',
      '/rewards': 'Rewards',
      '/cassa': 'Cassa',
      '/ordertracking': 'Order Tracking',
      '/rubrica': 'Rubrica',
      '/statistiche': 'Statistiche',
      '/turni': 'Turni',
    };

    // Aggiorna il titolo della pagina
    setTitle(document.title = routeTitles[location.pathname] || 'Reboot');
  }, [location]);

  useEffect(() => {
    if (!userDetails) return;

    const projectName = "reboot";
    const isPartOfProject = userDetails.Project?.some(project => project.name === projectName);
    const token = userDetails.token;

    // const otp = "6395404"; // Sostituisci con l'OTP reale dell'utente
    // const verifiedToken = verify2fa(token, otp)

    if (!isPartOfProject) {
    // if (!isPartOfProject && !verifiedToken(token)) {
      console.log(`User is not part of the ${projectName} project`);
      setUserDetails(null);
      localStorage.removeItem('authToken');
      sessionStorage.clear();
      window.location.href = `/login?message=Access%20denied.%20You%20are%20not%20part%20of%20the%20${projectName}%20project.`;
    }
  }, [userDetails]);

  // Verifica se l'utente si trova sulla pagina di login
  const isLoginPage = location.pathname === '/login';

  return (
    <>
      {isLoginPage ? (
        // Template per la pagina di login
        <div className="login-container">
          <Routes>
            <Route path="/login" element={<Login />} />
          </Routes>
        </div>
      ) : (
        <>
          {/* [ Pre-loader ] start */}
          <div className="loader-bg">
            <div className="loader-track">
              <div className="loader-fill" />
            </div>
          </div>
          {/* [ Pre-loader ] End */}
          {/* [ Main Content ] start */}
          <SearchContext.Provider value={{ toggleSearch, searchTerm, setSearchTerm, clearSearch: () => setSearchTerm(''), searchPlaceholder }}>
            <div className="wrapper">
              <Header userDetails={userDetails} setUserDetails={setUserDetails} />
              {searchMounted && (
                <div className={`footer-bar global-search-bar${searchOpen ? '' : ' is-closing'}`} style={{ '--global-search-top': `${searchTop}px` }}>
                  <div className="row align-items-start">
                    <div className="col-12 d-flex align-items-center">
                      <input
                        ref={searchInputRef}
                        type="search"
                        className="global-search-bar__input"
                        placeholder={searchPlaceholder}
                        aria-label="Cerca"
                        value={searchTerm}
                        onChange={(event) => setSearchTerm(event.target.value)}
                        autoFocus
                        onKeyDown={(event) => {
                          if (event.key === 'Escape') setSearchOpen(false);
                        }}
                        onBlur={(event) => {
                          const nextFocus = event.relatedTarget;
                          const lensClicked = nextFocus instanceof Element && nextFocus.closest('button[aria-label="Apri o chiudi la ricerca"]');
                          if (!lensClicked && !event.target.value) {
                            setSearchOpen(false);
                          }
                        }}
                      />
                      {searchTerm && (
                        <button
                          type="button"
                          className="global-search-bar__clear"
                          aria-label="Azzera ricerca"
                          onMouseDown={(event) => event.preventDefault()}
                          onClick={() => { setSearchTerm(''); searchInputRef.current?.focus(); }}
                        >
                          <span className="material-symbols-outlined">close</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className="page-wrap">
                <Navigation />
                <div className="main-content">
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/" element={<PrivateRoute><Home userDetails={userDetails} /></PrivateRoute>} />
                    <Route path="/academy" element={<PrivateRoute><Academy userDetails={userDetails} /></PrivateRoute>} />
                    <Route path="/account" element={<PrivateRoute><Account userDetails={userDetails} /></PrivateRoute>} />
                    <Route path="/bookmarks" element={<PrivateRoute><Bookmarks userDetails={userDetails} /></PrivateRoute>} />
                    <Route path="/cassa" element={<PrivateRoute><Cassa userDetails={userDetails} /></PrivateRoute>} />
                    <Route path="/ordertracking" element={<PrivateRoute><OrderTracking userDetails={userDetails} /></PrivateRoute>} />
                    <Route path="/rewards" element={<PrivateRoute><Rewards userDetails={userDetails} /></PrivateRoute>} />
                    <Route path="/rubrica" element={<PrivateRoute><Rubrica userDetails={userDetails} /></PrivateRoute>} />
                    <Route path="/statistiche" element={<PrivateRoute><Statistiche userDetails={userDetails} /></PrivateRoute>} />
                    <Route path="/turni" element={<PrivateRoute><Turni userDetails={userDetails} /></PrivateRoute>} />
                  </Routes>
                </div>
                {/* <Rightbar /> */}
                {/* <Chatpanel /> */}
                <Footer />
                <Modal userDetails={userDetails} />
              </div>
            </div>
          </SearchContext.Provider>
          {/* [ Main Content ] end */}
        </>
      )}
    </>
  );
}

export default App;